import { BROADCAST_MSG_AVAILABLE, EMPTY_BROADCAST_MSG, GET_BROADCAST_MSG_DETAILS } from '../actions/types';

let broadcastMsgDataState = { broadcastMsgs:[], totalPages:0, currentPage: 1, dataLimit: 5, broadcastMsgDetails: {} };

export default function (state = broadcastMsgDataState, action) {
    switch (action.type) {
        case BROADCAST_MSG_AVAILABLE:
            const incomingData = action.payload.content.message || [];
            
            if (state.broadcastMsgs.length === 0) {
                return {
                    ...state,
                    broadcastMsgs: incomingData,
                    totalPages: action.payload.content.totalPages,
                    currentPage: parseInt(action.payload.content.currentPage),
                    dataLimit: parseInt(action.payload.content.dataLimit)
                }
            } else {
                let concatResult = {};
                concatResult.broadcastMsgs = state.broadcastMsgs.concat(incomingData);
                concatResult.totalPages = action.payload.content.totalPages;
                concatResult.currentPage = parseInt(action.payload.content.currentPage);
                concatResult.dataLimit = parseInt(action.payload.content.dataLimit);

                return {
                    ...state,
                    broadcastMsgs: concatResult.broadcastMsgs,
                    totalPages: concatResult.totalPages,
                    currentPage: concatResult.currentPage,
                    dataLimit: concatResult.dataLimit,
                }
            }

        case EMPTY_BROADCAST_MSG:
            return { ...state, broadcastMsgs: [], totalPages: 0, currentPage: 1, dataLimit: 5 };

        case GET_BROADCAST_MSG_DETAILS:
            return { ...state, broadcastMsgDetails: action.payload.content }

        default:
            return state;
    }
}